import Skeleton from "../../common/Skeleton";

const PastBlocksSkeleton = () => {
  return (
    <>
      {[...Array(10)].map((_, index) => (
        <tr
          key={index}
          className="border-b border-[#d0d4e4] dark:border-[#394564]"
        >
          <td className="py-2 px-2">
            <Skeleton className="w-16 h-4 rounded" />
          </td>
          <td className="py-2 px-2">
            <div className="flex items-center gap-1">
              <Skeleton className="w-4 h-4 rounded-full" />
              <Skeleton className="w-20 h-4 rounded" />
            </div>
          </td>
          <td className="py-2 px-2">
            <div className="flex justify-end gap-1">
              <Skeleton className="w-12 h-4 rounded" />
              <Skeleton className="w-12 h-4 rounded" />
            </div>
          </td>
          <td className="py-2 px-2 text-center">
            <Skeleton className="w-16 h-4 mx-auto rounded-full" />
          </td>
          <td className="py-2 px-2 text-center">
            <Skeleton className="w-8 h-4 mx-auto rounded" />
          </td>
          {[...Array(6)].map((_, i) => (
            <td key={i} className="py-2 px-2 text-center">
              <Skeleton className="w-4 h-4 mx-auto rounded-full" />
            </td>
          ))}
          <td className="py-2 px-2 text-center">
            <div className="flex justify-center space-x-2">
              <Skeleton className="w-6 h-6 rounded-full" />
              <Skeleton className="w-6 h-6 rounded-full" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default PastBlocksSkeleton;
